import { ApolloClient, InMemoryCache, } from "@apollo/client";
import { onegraphLink } from "./link/onegraph-link";
const oneGraphClients = new Map();
function getClientId(options) {
    const { clientName, clientVersion, endpoint } = options;
    return `${clientName}@${clientVersion}-${endpoint}`;
}
/**
 * @deprecated # ⚠️ Do not use this library directly if you can avoid it.
 *
 * Using `@oneaudi/onegraph-client` directly requires consumers to correctly configure Authorization headers that are otherwise automatically handled by `@oneaudi/onegraph-service` in a properly configured integrator (e.g. within AEM).
 *
 * If you use `onegraph-client` directly without providing the JWT yourself, you will have trouble getting certain data from OneGraph ([read more about the issue](https://collaboration.msi.audi.com/confluence/pages/viewpage.action?spaceKey=COUNTRY&title=Preview+data+in+OneGraph)).
 *
 * When switching to `onegraph-service`, you can follow its [FeatureApp integration-instructions](https://github.com/oneaudi/onegraph-service#feature-apps).
 *
 * If you still need access to the Apollo client instance, the FeatureService — once made available in your FeatureApp — provides a method for that:
 * ```ts
 * const oneGraphClient = colaService.getApolloClient();
 * ```
 *
 * We use this deprecation JSDoc to ensure people see the warning directly in their development environment. We realize there are cases in which using `onegraph-client` directly is correct. In those cases, feel free to use the new `createOneGraphClientOverrideDeprecation` function exported by the module `onegraph-client` instead.
 */
export function createOneGraphClient(options) {
    const { clientName, clientVersion, ssrMode = false } = options;
    const clientId = getClientId(options);
    options.cacheConfig = {
        ...options.cacheConfig,
        // This prevents the cache from generating a cache key for any entity, ultimately disabling the flat mapping behavior. Only queries will be stored with their complete variables
        dataIdFromObject: () => false,
    };
    if (!oneGraphClients.has(clientId)) {
        oneGraphClients.set(clientId, {
            options: options,
            client: new ApolloClient({
                link: onegraphLink(options),
                ssrMode,
                cache: new InMemoryCache(options.cacheConfig),
                name: clientName,
                version: clientVersion,
            }),
        });
    }
    return oneGraphClients.get(clientId)?.client;
}
export const createOneGraphClientOverrideDeprecation = (...args) => createOneGraphClient(...args);
function removeClient(clientId) {
    if (oneGraphClients.has(clientId)) {
        const client = oneGraphClients.get(clientId);
        client.client.stop();
        client.client.cache.reset({ discardWatches: true }).finally(() => {
            client.client = null;
        });
        oneGraphClients.delete(clientId);
    }
}
export function deleteOneGraphClient(options) {
    const clientId = getClientId(options);
    removeClient(clientId);
}
export function deleteOneGraphClients() {
    oneGraphClients.forEach((client, clientId) => {
        removeClient(clientId);
    });
}
//# sourceMappingURL=onegraph-client.js.map